import type { Appointment } from '@medplum/fhirtypes';

export const CLIENT_LOCATION_CONFIRMATION_SOURCES = [
  'device_location_prefilled_client_attested',
  'ip_prefilled_client_attested',
  'manual_client_attested',
  'saved_address_client_attested',
] as const;

export type ClientLocationConfirmationSource = (typeof CLIENT_LOCATION_CONFIRMATION_SOURCES)[number];

export type LocationPrefillSource = 'device_location' | 'saved_address' | 'manual' | 'none' | 'ip';

export interface LocationConfirmationInput {
  street: string;
  city: string;
  state: string;
  postalCode: string;
  notAtUsualAddress: boolean;
  attestationAccepted: boolean;
  prefillSource: LocationPrefillSource;
  wasEditedAfterPrefill: boolean;
  ipDerivedCity?: string;
  ipDerivedState?: string;
}

export interface ClientLocationConfirmation {
  street: string;
  city: string;
  state: string;
  postalCode: string;
  confirmedAt: string;
  attestationText: string;
  attestationVersion: string;
  source: ClientLocationConfirmationSource;
  confirmedByPatientId: string;
  practitionerId?: string;
  wasEditedAfterPrefill: boolean;
  ipDerivedCity?: string;
  ipDerivedState?: string;
  stateMismatch: boolean;
  licensureBlocking: boolean;
  notAtUsualAddress: boolean;
  appointmentId: string;
}

export interface LocationConfirmationResult {
  confirmation: ClientLocationConfirmation;
  appointment?: Appointment;
}
